
import 'bootstrap/dist/css/bootstrap.min.css';
import { Routes , Route } from 'react-router-dom';
import HomePage from './pages/Home';
import EditPage from './pages/Edit';
import './App.css';
import { FaMoon, FaSun } from 'react-icons/fa';
import { useState , useEffect } from 'react';



function App() {

  const [darkMode , setDarkMode] = useState(true);

  const toggleTheme = () => {
    setDarkMode((prev) => !prev);
  }

  useEffect(() => {
    document.body.className = darkMode ? 'dark' : 'light';
  }, [darkMode]);

  return (
    <div >
  <div className="container py-4">
    <h1 className="text-center mb-4 text-warning">Meme Generator App</h1>
    <button className="toggle-theme-btn" onClick={toggleTheme}>
          {darkMode ? <FaSun title="Switch to Light Mode" /> : <FaMoon title="Switch to Dark Mode" />}
        </button>
    <Routes>
      <Route path='/' element={<HomePage />} />
      <Route path='/edit/' element={<EditPage />} />
    </Routes>
  </div>
</div>
  )
}

export default App;
